import React from 'react';

import ConfigureSoloPageSegment from '../components/ConfigureSoloPageSegment';
import ConfigureTeamPageSegment from '../components/ConfigureTeamPageSegment';
import CompatibilitySegment from '../components/CompatibilitySegment';
import PageRoot from '../components/PageRoot';
import WhatsInTheBoxSegment from '../components/WhatsInTheBoxSegment';
import withReservation from '../utils/Reservation';

const propTypes = {};

class Configure extends React.Component {
  constructor(props) {
    super(props);
    this.compatibilitySegmentRef = React.createRef();
  }

  render() {
    const { cart } = this.props;
    return (
      <PageRoot>
        {cart.plan === 'TEAM' ? (
          <ConfigureTeamPageSegment
            compatibilitySegmentRef={this.compatibilitySegmentRef}
          />
        ) : (
          <ConfigureSoloPageSegment
            compatibilitySegmentRef={this.compatibilitySegmentRef}
          />
        )}
        <CompatibilitySegment ref={this.compatibilitySegmentRef} />
        <WhatsInTheBoxSegment />
      </PageRoot>
    );
  }
}

Configure.propTypes = propTypes;

export default withReservation(Configure);
